//접속 환경 확인 (브라우저·버전·접속 주소·화면 버전·쿠키/저장소 사용 가능 여부)
//- 쿠키가 막힌 브라우저에서는 알림 읽음·아이디 저장·검색 조건 기억이 조용히 저장되지 않아서, 로그인 때 기록해 두고 문의 때 확인
//- 쿠키 안내(오른쪽 아래)도 여기 값을 씀

//쿠키 저장·읽기 가능 여부 (앱 쿠키와 같은 조건: path=/, https 면 Secure)
export function cookieWorks() {
    try {
        if (navigator.cookieEnabled === false) return false;
        const name = 'pasm_cookie_test';
        const secure = location.protocol === 'https:' ? '; Secure' : '';
        document.cookie = name + '=1; path=/; SameSite=Lax' + secure;
        const ok = document.cookie.indexOf(name + '=1') > -1;
        document.cookie = name + '=; path=/; max-age=0' + secure;
        return ok;
    } catch (e) {
        return false;
    }
}

//브라우저 저장소(localStorage) 사용 가능 여부 — 로그인 정보가 여기 있음
export function storageWorks() {
    try {
        const k = '__pasm_storage_test';
        localStorage.setItem(k, '1');
        localStorage.removeItem(k);
        return true;
    } catch (e) {
        return false;
    }
}

//브라우저 이름·버전 (Edge·Whale·크롬·파이어폭스·사파리)
export function browserInfo() {
    const ua = navigator.userAgent || '';
    const pick = (re) => { const m = ua.match(re); return m ? m[1] : ''; };
    let name = '기타', version = '';
    if (/Edg\//.test(ua)) { name = 'Edge'; version = pick(/Edg\/([\d.]+)/); }
    else if (/Edge\//.test(ua)) { name = 'Edge(구버전)'; version = pick(/Edge\/([\d.]+)/); }
    else if (/Whale\//.test(ua)) { name = 'Whale'; version = pick(/Whale\/([\d.]+)/); }
    else if (/Firefox\//.test(ua)) { name = 'Firefox'; version = pick(/Firefox\/([\d.]+)/); }
    else if (/Chrome\//.test(ua)) { name = 'Chrome'; version = pick(/Chrome\/([\d.]+)/); }
    else if (/Safari\//.test(ua)) { name = 'Safari'; version = pick(/Version\/([\d.]+)/); }
    return { name, version, ua };
}

//화면 버전 = 지금 실행 중인 app.[해시].js (배포마다 바뀜 → 예전 화면에 머무는지 확인용)
export function buildVersion() {
    const s = [...document.querySelectorAll('script[src]')].map(e => e.getAttribute('src')).find(src => /\/js\/app\.[0-9a-f]+\.js/.test(src));
    const m = s && s.match(/app\.([0-9a-f]+)\.js/);
    return m ? m[1] : 'dev';
}

export function clientEnv() {
    const b = browserInfo();
    return {
        browser: b.name,
        browser_version: b.version,
        os: navigator.platform || '',
        url: location.origin,
        build: buildVersion(),
        cookie: cookieWorks(),
        storage: storageWorks(),
        screen: (window.screen ? window.screen.width + 'x' + window.screen.height : ''),
        ua: b.ua,
    };
}

//로그인 때 접속 기록(SHELTER_PASM_ACCESS_LOG)에 접속 환경을 남김 — 실패해도 사용자에게 알리지 않음
export function logClientEnv(axios, common, shelterDeviceNumber) {
    try {
        const log = {
            shelter: shelterDeviceNumber,
            type: '접속 환경',
            page_name: '로그인',
            processing_information: JSON.stringify(clientEnv()),
        };
        const formData = new FormData();
        formData.append('pasmAccessLog', common.convertFormData(log));
        axios.post('/log', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).catch(() => {});
    } catch (e) { /* noop */ }
}
